'use client';

import ArrowUpward from '@mui/icons-material/ArrowUpward';
import VerticalAlignTop from '@mui/icons-material/VerticalAlignTop';
import Link, { type LinkProps } from '@mui/material/Link';
import Typography from '@mui/material/Typography';

type Props = LinkProps & {
  arrowStyle?: 'simple' | 'fancy';
  scrollBehavior?: 'auto' | 'smooth';
};

export function BackToTop({
  arrowStyle = 'simple',
  scrollBehavior = 'smooth',
  sx,
  ...linkProps
}: Props) {
  return (
    <Link
      href="#"
      sx={{
        width: 'fit-content',
        color: 'blue.primary',
        alignItems: 'center',
        display: 'flex',
        gap: 1,
        ...(Array.isArray(sx) ? sx : [sx]),
      }}
      {...linkProps}
      onClick={e => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: scrollBehavior });
      }}
    >
      {arrowStyle === 'simple' && <ArrowUpward />}
      <Typography>Back to top</Typography>
      {arrowStyle === 'fancy' && <VerticalAlignTop />}
    </Link>
  );
}
